<template>
  <div>
    <div v-for="manufacturingSeries in topologyItem.ManufacturingSeries" :key="manufacturingSeries.ManufacturingSeriesId">
      <b-form-checkbox class="ml-3" :style="'padding-left:' + paddingLeft + 'rem'" v-model="manufacturingSeries.Download" @change="setDownload(manufacturingSeries, manufacturingSeries.Download)">
        <h5>
          {{ manufacturingSeries.DisplayName }}
          <span class="smaller float-md-right mx-2"><b-badge style="font-size: 10px">Manufacturing Series</b-badge></span>
        </h5>
      </b-form-checkbox>
      <products
        :topologyItem="manufacturingSeries" :paddingLeft="paddingLeft + 2" @checkParent="checkParent" />
    </div>
  </div>
</template>
<script lang="ts">
import { Component, Mixins, Prop } from 'vue-property-decorator'
import Products from './products.vue'
@Component({
  components: {
    'products': Products,
  },
})

export default class extends Mixins() {
  @Prop()
  public topologyItem!: any

  @Prop()
  public paddingLeft!: number

  public checkParent() {
    this.topologyItem.Download = true
    this.$emit('checkParent')
  }

  public setDownload(item: any, value: boolean) {
    if (value) {
      this.checkParent()
    }
    item.Products?.forEach((p) => {
      p.Download = value
      p.Sections?.forEach((s) => {
        s.Download = value
        s.Tabs?.forEach((t) => {
          t.Download = value
          t.Tables?.forEach((ta) => {
            ta.Download = value
            ta.Models?.forEach((m) => {
              m.Download = value
            })
          })
        })
      })
    })
  }
}
</script>
